<template>
    <div>
        <page-navigate></page-navigate>
        <div class="oxford-wrapper" :class="$t('common.lang') + ' ' + $t('common.fontFamily')">
            <section class="section1">
                <div class="section1Popover"><a href="#section6" class="word4">{{ $t('oxfordNew.word4') }}</a></div>
                <h1 class="cn-font-family-title word1">EBC金融集团与牛津大学<br class="mobile">经济系</h1>
      <h2 class="word2">一项为期3年的续签合作，帮助更多人理解经济学如何影响市场、<br class="pc">政策与日常决策。</h2>

                <img src="@/assets/image/ESG/oxford-logo2.png" class="session1-logo2" alt="" />
                <a href="#section3" class="section1Btn word3">{{ $t('oxfordNew.word3') }}</a>
            </section>
            <div class="navList">
                <a href="#section2" class="navListSection2 word5">{{ $t('oxfordNew.word5') }}</a>
                <a href="#section3" class="navListSection3 word6">{{ $t('oxfordNew.word6') }}</a>
                <a href="#section4" class="navListSection4 word7">{{ $t('oxfordNew.word7') }}</a>
                <a href="#section5" class="navListSection5 word8">{{ $t('oxfordNew.word8') }}</a>
            </div>
            <section class="section2" id="section2">

                <div class="content">
                    <div class="left">
                        <h2 class="cn-font-family-title word9">打开通往牛津经济洞察之门</h2>
          <div class="word word12">一些最有价值的经济研究很少能触达学术界或政策圈之外的人群。通过EBC金融集团与牛津大学经济系续签的三年合作，“经济学家到底在做什么”（WERD）系列让这些内容能够更广泛地被公众获取。</div>
          <div class="word word10">每一场由EBC赞助的网络研讨会都会连接牛津大学经济学家与学生、校友、研究人员及公众，涵盖广泛的经济学主题。</div>
        </div>
                    <div class="right">
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/qJhHVCMcyn0?si=z4M3ZUbCQxxpWGTj" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>
            </section>
            <section class="section3" id="section3">
                <h2 class=" word13" :class="$t('common.fontFamilyTitle')">{{ $t('oxfordNew.word13') }}</h2>
                <div class="oxford-slide swiper">
                    <div class="swiper-wrapper">
                          <div class="swiper-slide">
                            <div class="slide-img">
                               <iframe width="560" height="315" src="https://www.youtube.com/embed/VqmooNuDSUQ?si=N6ftv6norhft6JKo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                            <div class="content content1">
                                <div class="topTitle">
                                    <div class="order word14">{{ $t('oxfordNew.word14') }}</div>
                                    <div class="title  word15" :class="$t('common.fontFamilyTitle')">{{
                                        $t('oxfordNew.word15') }}</div>
                                </div>
                                <div class="splitLine"></div>
                                <div class="descriptionBox">
                                    <div class="details contentBox">
                                        <div class="title word16">{{ $t('oxfordNew.word16') }}</div>
                                        <div class="describe word17">{{ $t('oxfordNew.word17') }}</div>
                                    </div>
                                    <div class="date contentBox">
                                        <div class="title word22">{{ $t('oxfordNew.word22') }}</div>
                                        <div class="describe">
                                            <span class="word23">{{ $t('oxfordNew.word23') }}</span>
                                            <span class="word24">{{ $t('oxfordNew.word24') }}</span>
                                        </div>
                                    </div>
                                    <div class="speakers contentBox">
                                        <div class="title word18">{{ $t('oxfordNew.word18') }}</div>
                                        <div class="describe">
                                            <ul>
                                                <li class="word19">{{ $t('oxfordNew.word19') }}</li>
                                                <li class="word20">{{ $t('oxfordNew.word20') }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="format contentBox">
                                        <div class="title word25">{{ $t('oxfordNew.word25') }}</div>
                                        <div class="describe word26">{{ $t('oxfordNew.word26') }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="slide-img">
                                <iframe width="560" height="315" src="https://www.youtube.com/embed/MD5vaMjQdkc?si=nQmLnCxRo5HJbNb5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>

                            <div class="content content1">
                                <div class="topTitle">
                                    <div class="order word27">{{ $t('oxfordNew.word27') }}</div>
                                    <div class="title  word28" :class="$t('common.fontFamilyTitle')">{{
                                        $t('oxfordNew.word28') }}</div>
                                </div>
                                <div class="splitLine"></div>
                                <div class="descriptionBox">
                                    <div class="details contentBox">
                                        <div class="title word16">{{ $t('oxfordNew.word16') }}</div>
                                        <div class="describe word29">{{ $t('oxfordNew.word29') }}</div>
                                    </div>
                                    <div class="date contentBox">
                                        <div class="title word22">{{ $t('oxfordNew.word22') }}</div>
                                        <div class="describe word34">{{ $t('oxfordNew.word34') }}</div>
                                    </div>
                                    <div class="speakers contentBox">
                                        <div class="title word18">{{ $t('oxfordNew.word18') }}</div>
                                        <div class="describe">
                                            <ul>
                                                <li class="word30">{{ $t('oxfordNew.word30') }}</li>
                                                <li class="word31">{{ $t('oxfordNew.word31') }}</li>
                                                <li class="word32">{{ $t('oxfordNew.word32') }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="format contentBox">
                                        <div class="title word25">{{ $t('oxfordNew.word34') }}</div>
                                        <div class="describe word35">{{ $t('oxfordNew.word35') }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                        
                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>

            </section>
            <section class="section4" id="section4">
                <h2 class=" word36" :class="$t('common.fontFamilyTitle')">{{ $t('oxfordNew.word36') }}</h2>
                <div class="swiper oxford-slide2">
                    <div class="swiper-wrapper sectionContainer">
                        
                        
                        
                        
                        
                        <div class="box swiper-slide">
                            <img src="@/assets/image/oxfordNew/section4Content6.png" alt="" />
                            <div class="right">
                                <div class="word1  word52" :class="$t('common.fontFamilyTitle')">{{
                                    $t('oxfordNew.word52') }}</div>
                                <div class="word2 word53">{{ $t('oxfordNew.word53') }}</div>
                                <div class="word3 word54">{{ $t('oxfordNew.word54') }}</div>

                                <a href="https://economics.web.ox.ac.uk/people/abi-adams-prassl-1" target="_blank">
                                    <div class="btn1 word55">{{ $t('oxfordNew.word55') }}</div>
                                </a>
                            </div>
                        </div>
                        <div class="box swiper-slide">
                            <img src="@/assets/image/oxfordNew/section4Content5.png" alt="" />
                            <div class="right">
                                <div class="word1  word49" :class="$t('common.fontFamilyTitle')">{{
                                    $t('oxfordNew.word49') }}</div>
                                <div class="word2 word50">{{ $t('oxfordNew.word50') }}</div>
                                <div class="word3 word51">{{ $t('oxfordNew.word51') }}</div>

                                <a href="https://economics.web.ox.ac.uk/people/sarah-clifford " target="_blank">
                                    <div class="btn1 word55">{{ $t('oxfordNew.word55') }}</div>
                                </a>
                            </div>
                        </div>
                       
                        <div class="box swiper-slide">
                            <img src="@/assets/image/oxfordNew/section4Content3.png" alt="" />
                            <div class="right">
                                <div class="word1  word43" :class="$t('common.fontFamilyTitle')">{{
                                    $t('oxfordNew.word43') }}</div>
                                <div class="word2 word44">{{ $t('oxfordNew.word44') }}</div>
                                <div class="word3 word45">{{ $t('oxfordNew.word45') }}</div>
                                <a href="https://economics.web.ox.ac.uk/people/banu-demir-pakel" target="_blank">
                                    <div class="btn1 word55">{{ $t('oxfordNew.word55') }}</div>

                                </a>
                            </div>
                        </div>
                        <div class="box swiper-slide">
                            <img src="@/assets/image/oxfordNew/section4Content2.png" alt="" />
                            <div class="right">
                                <div class="word1  word40" :class="$t('common.fontFamilyTitle')">{{
                                    $t('oxfordNew.word40') }}</div>
                                <div class="word2 word41">{{ $t('oxfordNew.word41') }}</div>
                                <div class="word3 word42">{{ $t('oxfordNew.word42') }}</div>

                                <a href="https://www.economics.ox.ac.uk/people/andrea-chiavari " target="_blank">
                                    <div class="btn1 word55">{{ $t('oxfordNew.word55') }}</div>
                                </a>
                            </div>
                        </div>
                        <div class="box swiper-slide">
                            <img src="@/assets/image/oxfordNew/section4Content1.png" alt="" />
                            <div class="right">
                                <div class="word1  word37" :class="$t('common.fontFamilyTitle')">{{
                                    $t('oxfordNew.word37') }}</div>
                                <div class="word2 word38">{{ $t('oxfordNew.word38') }}</div>
                                <div class="word3 word39">{{ $t('oxfordNew.word39') }}</div>
                                <a href="https://www.ox.ac.uk/news-and-events/find-an-expert/dr-nicola-ranger "
                                    target="_blank">
                                    <div class="btn1 word55">{{ $t('oxfordNew.word55') }}</div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="section5" id="section5">
                <h2 class=" word56" :class="$t('common.fontFamilyTitle')">{{ $t('oxfordNew.word56') }}</h2>
                <!-- <div class="section5Container pc">
                    <a :href="$t('common.requestLang') == 'zh_CN' ? 'https://ebcfin.info/jinrong/116258.html' : $t('common.requestLang') == 'zh_TW' ? 'https://www.ebc.com/zh/jinrong/116261.html ' : 'https://www.ebc.com/forex/114259.html'"
                        target="_blank">
                        <div class="box">
                            <div class="word">
                                <div>
                                    {{ $t('common.requestLang') == 'zh_CN' ? '从化石燃料到绿色未来：牛津大学携手EBC金融集团探讨全球气候挑战'
                                        : $t('common.requestLang') == 'zh_TW' ? '從化石燃料到綠色未來：牛津大學攜手EBC金融集團探討全球氣候挑戰' :`Oxford
                                    and
                                    EBC Financial Group on What's Holding Us Back`}}
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="19" viewBox="0 0 13 19"
                                    fill="none">
                                    <path
                                        d="M3.54545 0L0 3.54545L5.90909 9.45455L0 15.3636L3.54545 18.9091L13 9.45455L3.54545 0Z"
                                        fill="#FFB50E" />
                                </svg>
                            </div>
                        </div>
                    </a>
                    <a :href="$t('common.requestLang') == 'zh_CN' ? 'https://ebcfin.info/jinrong/37455.html ' : $t('common.requestLang') == 'zh_TW' ? 'https://www.ebc.com/zh/jinrong/37457.html ' : 'https://www.ebc.com/forex/107193.html'"
                        target="_blank">
                        <div class="box">
                            <div class="word">
                                <div>
                                    {{ $t('common.requestLang') == 'zh_CN' ? 'EBC联合牛津大学研讨会：从避税经济看监管趋势'
                                        : $t('common.requestLang') == 'zh_TW' ? 'EBC聯合牛津大學研討會：從避稅經濟看監理趨勢' : `EBC and Oxford's
                                    WERD Series Brings Fresh Perspectives on Climate and Economy`}}
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="19" viewBox="0 0 13 19"
                                    fill="none">
                                    <path
                                        d="M3.54545 0L0 3.54545L5.90909 9.45455L0 15.3636L3.54545 18.9091L13 9.45455L3.54545 0Z"
                                        fill="#FFB50E" />
                                </svg>
                            </div>
                        </div>
                    </a>
                    <a :href="$t('common.requestLang') == 'zh_CN' ? 'https://ebcfin.info/jinrong/31415.html' : $t('common.requestLang') == 'zh_TW' ? 'https://www.ebc.com/zh/jinrong/30681.html ' : 'https://www.ebc.com/forex/101236.html '"
                        target="_blank">
                        <div class="box">
                            <div class="word">
                                <div>
                                    {{ $t('common.requestLang') == 'zh_CN' ? 'EBC集团联合牛津大学经济学系探讨避税真相'
                                        : $t('common.requestLang') == 'zh_TW' ? 'EBC金融集團聯合牛津大學舉辦研討會' :`EBC and the
                                    University
                                    of Oxford's Department of Economics Announce WERD Episode`}}
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="19" viewBox="0 0 13 19"
                                    fill="none">
                                    <path
                                        d="M3.54545 0L0 3.54545L5.90909 9.45455L0 15.3636L3.54545 18.9091L13 9.45455L3.54545 0Z"
                                        fill="#FFB50E" />
                                </svg>
                            </div>
                        </div>
                    </a>


                </div>
                <div class="oxford-slide3 swiper mobile">
                    <div class="section5Container  swiper-wrapper">
                        <div class="box swiper-slide">
                            <a :href="$t('common.requestLang') == 'zh_CN' ? 'https://ebcfin.info/jinrong/116258.html' : $t('common.requestLang') == 'zh_TW' ? 'https://www.ebc.com/zh/jinrong/116261.html ' : 'https://www.ebc.com/forex/114259.html'"
                                target="_blank">
                                <div class="word">
                                    <div>
                                        {{ $t('common.requestLang') == 'zh_CN' ? '从化石燃料到绿色未来：牛津大学携手EBC金融集团探讨全球气候挑战'
                                            : $t('common.requestLang') == 'zh_TW' ? '從化石燃料到綠色未來：牛津大學攜手EBC金融集團探討全球氣候挑戰'
                                                :`Oxford
                                        and EBC Financial Group on What's Holding Us Back`}}
                                    </div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="19" viewBox="0 0 13 19"
                                        fill="none">
                                        <path
                                            d="M3.54545 0L0 3.54545L5.90909 9.45455L0 15.3636L3.54545 18.9091L13 9.45455L3.54545 0Z"
                                            fill="#FFB50E" />
                                    </svg>
                                </div>
                            </a>
                        </div>

                        <div class="box swiper-slide">
                            <a :href="$t('common.requestLang') == 'zh_CN' ? 'https://ebcfin.info/jinrong/37455.html ' : $t('common.requestLang') == 'zh_TW' ? 'https://www.ebc.com/zh/jinrong/37457.html ' : 'https://www.ebc.com/forex/107193.html'"
                                target="_blank">

                                <div class="word">
                                    <div>
                                        {{ $t('common.requestLang') == 'zh_CN' ? 'EBC联合牛津大学研讨会：从避税经济看监管趋势'
                                            : $t('common.requestLang') == 'zh_TW' ? 'EBC聯合牛津大學研討會：從避稅經濟看監理趨勢' : `EBC and
                                        Oxford's WERD Series Brings Fresh Perspectives on Climate and Economy`}}
                                    </div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="19" viewBox="0 0 13 19"
                                        fill="none">
                                        <path
                                            d="M3.54545 0L0 3.54545L5.90909 9.45455L0 15.3636L3.54545 18.9091L13 9.45455L3.54545 0Z"
                                            fill="#FFB50E" />
                                    </svg>
                                </div>
                            </a>

                        </div>
                        <div class="box swiper-slide">
                            <a :href="$t('common.requestLang') == 'zh_CN' ? 'https://ebcfin.info/jinrong/31415.html' : $t('common.requestLang') == 'zh_TW' ? 'https://www.ebc.com/zh/jinrong/30681.html ' : 'https://www.ebc.com/forex/101236.html '"
                                target="_blank">
                                <div class="word">
                                    <div>
                                        {{ $t('common.requestLang') == 'zh_CN' ? 'EBC集团联合牛津大学经济学系探讨避税真相'
                                            : $t('common.requestLang') == 'zh_TW' ? 'EBC金融集團聯合牛津大學舉辦研討會' : `EBC and the
                                        University of Oxford's Department of Economics Announce WERD Episode`}}
                                    </div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="19" viewBox="0 0 13 19"
                                        fill="none">
                                        <path
                                            d="M3.54545 0L0 3.54545L5.90909 9.45455L0 15.3636L3.54545 18.9091L13 9.45455L3.54545 0Z"
                                            fill="#FFB50E" />
                                    </svg>
                                </div>
                            </a>
                        </div>
                    </div>
                </div> -->
                <div class="partnerList">
                    <img src="@/assets/image/oxfordNew/partner1.png" alt="" />
                    <img src="@/assets/image/oxfordNew/partner2.png" alt="" />
                    <img src="@/assets/image/oxfordNew/partner3.png" alt="" />
                    <img src="@/assets/image/oxfordNew/partner4.png" alt="" />
                    <img src="@/assets/image/oxfordNew/partner5.png" alt="" />
                    <img src="@/assets/image/oxfordNew/partner6.png" alt="" />
                    <img src="@/assets/image/oxfordNew/partner7.png" alt="" />
                    <img src="@/assets/image/oxfordNew/partner8.png" alt="" />
                </div>
            </section>
            <section class="section6" id="section6">
                <div class="left">
                    <div class="title  word57" :class="$t('common.fontFamilyTitle')">{{ $t('oxfordNew.word57') }}</div>
                    <div class="describe word58">{{ $t('oxfordNew.word58') }}</div>
                </div>
                <form class="right">
                    <input id="formName" type="text" :placeholder="$t('oxfordNew.placeholder1')" />
                    <input id="formTel" type="text" :placeholder="$t('oxfordNew.placeholder2')" />
                    <input id="formEmail" type="text" :placeholder="$t('oxfordNew.placeholder3')" />
                    <div style="position: relative;">
                        <input id="formVerify" type="text" :placeholder="$t('oxfordNew.placeholder4')" />
                        <!-- <captcha font-size="22" length="3" style="position:absolute;top:8rem;right:10rem"> -->
                        <div class="verify-img" style="position:absolute;top:8rem;right:10rem" @click="refreshCode">
                            <ss-code :identifyCode="identifyCode"></ss-code>
                        </div>
                    </div>
                    <button id="oxford-submit" class="word59">{{ $t('oxfordNew.word59') }}</button>
                </form>
            </section>
        </div>
        <page-footer></page-footer>
    </div>
</template>

<script>
import 'swiper/css/swiper.css'
import Swiper from 'swiper'
export default {

    data() {
        return {
            seoInfo: "",
            identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz", //随机串内容,从这里随机抽几个显示验证码
            identifyCode: "", //验证码图片内容
            urlObj:{
                en:'',
                ja:'jp/',
                ko:'kr/',
                zh:'zh-cn/',
                ct:'zh/',
                th:'th/',
                vn:'vi/'
            }
        }
    },

    created() {
    },
    mounted() {
        
        this.initPage(this)
        this.dealBarrett()
        // 初始化验证码
        this.identifyCode = "";
        //参数：（1）随机串内容。（2）验证码显示位数
        this.makeCode(this.identifyCodes, 4);
    },
    methods: {
        initPage(innerThis) {
            let mySwiper = new Swiper(".oxford-slide", {
                // loop: true,
                // autoplay: {
                //   delay:5000
                // },
                slidesPerView: "auto",
                spaceBetween: 25,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
            let mySwiper2 = new Swiper(".oxford-slide2", {
                slidesPerView: "auto",
                centeredSlides: true,
                spaceBetween: 30,
                autoplay: {
                    delay: 5000,
                },
                // loop: true,
            });
            let mySwiper3 = new Swiper(".oxford-slide3", {
                slidesPerView: "auto",
                centeredSlides: true,
                spaceBetween: 0,
                autoplay: {
                    delay: 5000,
                },
                // loop: true,
            });
            const navList = document.querySelector(".navList");
const sections = document.querySelectorAll('#section2, #section3, #section4, #section5');
const navItems = navList ? navList.children : [];

// 固定的顶部 header 高度
const HEADER_HEIGHT = 80; 

let ticking = false;
let isClicking = false; 
let clickTimeout = null;

// 1. 🚨 纯 JS 接管点击跳转逻辑
if (navItems.length > 0) {
  Array.from(navItems).forEach((item, index) => {
    item.addEventListener('click', (e) => {
      // 阻止浏览器原生的锚点跳转行为 (这步最关键)
      e.preventDefault(); 
      
      const targetSection = sections[index];
      if (!targetSection) return;

      // 获取当前导航栏的动态高度
      const navHeight = navList.offsetHeight;

      // 计算需要滚动到的精准绝对位置：
      // 目标元素距离视口顶部的距离 + 当前页面已经滚动的距离 - 顶部两个遮挡物的高度
      const targetTop = targetSection.getBoundingClientRect().top + window.scrollY;
      const scrollToPosition = targetTop - HEADER_HEIGHT - navHeight;

      // 开启点击锁：告诉滚动监听器“现在是我用 JS 在滚，你别乱切高亮”
      isClicking = true; 
      updateActive(navItems, index); // 强制立刻高亮当前项
      
      // 用 JS 执行平滑滚动
      window.scrollTo({
        top: scrollToPosition,
        behavior: 'smooth'
      });

      // 设定定时器，等待滚动动画结束后解锁（1000ms 足够覆盖 smooth scroll 的时间）
      clearTimeout(clickTimeout);
      clickTimeout = setTimeout(() => { 
        isClicking = false; 
      }, 1000); 
    });
  });
}

// 2. 正常滚动状态更新逻辑（保持极简）
function updateNavStatus() {
  if (isClicking || !navList || navList.style.display === 'none') return;
  if (sections.length === 0) return;

  // 触发线：80px(Header) + 导航栏实际高度 + 20px(容错缓冲)
  const triggerOffset = HEADER_HEIGHT + navList.offsetHeight + 20; 

  // 触底保护
  if (window.innerHeight + Math.ceil(window.scrollY) >= document.body.offsetHeight - 2) {
    updateActive(navItems, sections.length - 1);
    return;
  }

  // 倒序遍历
  for (let i = sections.length - 1; i >= 0; i--) {
    const rect = sections[i].getBoundingClientRect();
    if (rect.top <= triggerOffset) {
      updateActive(navItems, i);
      return; 
    }
  }
}

// 更新高亮的工具函数
function updateActive(items, activeIndex) {
  const currentActive = document.querySelector('.navList > .active');
  if (currentActive) currentActive.classList.remove('active');
  if (items[activeIndex]) items[activeIndex].classList.add('active');
}

// 3. 性能优化的滚动监听
window.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      updateNavStatus();
      ticking = false;
    });
    ticking = true;
  }
}, { passive: true });

            $("#oxford-submit").click(function (e) {
                e.preventDefault();
                var name = $("#formName").val();
                var gender = $(".select-label--active").text();
                var phone_email = $("#formEmail").val();
                var phone = $("#formTel").val();
                var lang = ""
                // var areaSpan = document.getElementById("areaSpan")
                //   ? document.getElementById("areaSpan").textContent
                //   : "";
                // if (areaSpan) {
                //   phone = areaSpan + phone;
                //   console.log("areaSpan", phone);
                // }
                var verify = $("#formVerify").val();
                var msg_name = "";
                var msg_phone_email = "";
                var msg_verify = "";
                if (innerThis.$i18n.locale == 'zh') {
                    lang = "cn"
                    msg_name = "请输入您的称呼!";
                    msg_phone_email = "请输入您的邮箱!";
                    msg_verify = "请输入验证码!";
                } else if (innerThis.$i18n.locale == 'ja') {
                    lang = "jp"
                    msg_name = "タイトルを入力してください！";
                    msg_phone_email = "あなたのメールアドレスを入力してください！";
                    msg_verify = "確認コードを入力してください!";
                } else if (innerThis.$i18n.locale == 'ko') {
                    lang = "kr"
                    msg_name = "제목을 입력해주세요!";
                    msg_phone_email = "이메일을 입력해주세요!";
                    msg_verify = "인증번호를 입력해주세요!";
                } else if (innerThis.$i18n.locale == 'th') {
                    lang = "th"
                    msg_name = "กรุณากรอกชื่อของคุณ";
                    msg_phone_email = "กรุณากรอกอีเมล์ของคุณ!";
                    msg_verify = "กรุณากรอกรหัสยืนยัน!";
                } else if (innerThis.$i18n.locale == 'vn') {
                    lang = "vi"
                    msg_name = "Vui lòng nhập tên của bạn";
                    msg_phone_email = "Vui lòng nhập email của bạn!";
                    msg_verify = "Vui lòng nhập mã xác nhận!";
                } else if (innerThis.$i18n.locale == 'ct') {
                    lang = "zh"
                    msg_name = "請輸入您的稱呼!";
                    msg_phone_email = "請輸入您的信箱!";
                    msg_verify = "請輸入驗證碼!";
                } else {
                    lang = "en"
                    msg_name = "Please enter your name!";
                    msg_phone_email = "Please enter your email!";
                    msg_verify = "Please enter verification code!";
                }
                if (name == "") {
                    msg_alert(msg_name);
                    return false;
                }
                if (phone_email == "") {
                    msg_alert(msg_phone_email);
                    return false;
                }
                if (verify == "") {
                    msg_alert(msg_verify);
                    return false;
                }
                $.ajax({
                    type: "POST",
                    url: "https://ebc.com/contact-us/formSubmit/",
                    dataType: "json",
                    data: {
                        name: name,
                        gender: gender,
                        phone_email: phone_email,
                        verify: verify,
                        lang: lang,
                        phone: phone,
                    },
                    async: false,
                    error: function (request) {
                        msg_alert("提交失败，请联系客服");
                    },
                    success: function (da) {
                        if (da.code == 1) {
                            msg_alert(da.msg);
                            $(".verify_img").click();
                        } else {
                            msg_alert(da.msg);
                        }
                    },
                });
            });

            function msg_alert(msg) {
                $("html").append(
                    '<div id="contact-alert" style="font-family: siyuan;  padding: 6px 20px; color: rgb(255, 255, 255); text-align: center; border-radius: 4px; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 999999; background: rgba(0, 0, 0, 0.7); font-size: 16px; transition: -webkit-transform 0.5s ease-in 0s, opacity 0.5s ease-in 0s;">' +
                    msg +
                    "</div>"
                );
                setTimeout(function () {
                    $("#contact-alert").remove();
                }, 2500);
            }
        },
        dealBarrett() {
            let barrettTarget
            if (this.$i18n.locale == 'zh') {
                barrettTarget = 'https://ebcfin.info/jinrong/25755.html'
            } else if (this.$i18n.locale == 'ct') {
                barrettTarget = 'https://www.ebc.com/forex/25759.html'
            } else if (this.$i18n.locale == 'ja') {
                barrettTarget = 'https://www.ebc.com/jp/forex/25762.html'
            } else if (this.$i18n.locale == 'ko') {
                barrettTarget = 'https://www.ebc.com/kr/forex/25763.html'
            } else if (this.$i18n.locale == 'th') {
                barrettTarget = 'https://www.ebc.com/th/forex/25761.html'
            } else if (this.$i18n.locale == 'vn') {
                barrettTarget = 'https://www.ebc.com/vi/forex/25769.html '
            } else {
                barrettTarget = 'https://www.ebc.com/forex/25759.html'
            }

            $('#BarrettUrl')[0].href = barrettTarget
        },
        // 重置验证码
        refreshCode() {
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
        },
        //获取验证码的值
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                //通过循环获取字符串内随机几位
                this.identifyCode +=
                    this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
            }
        },
        //随机数字：用于当角标拿字符串的值
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
    },

    watch: {
        '$i18n.locale': {
            handler(newVal) {
                document.title = this.$i18n.messages[this.$i18n.locale].oxfordNew.title

            },
            immediate: true, // 立即触发一次
        },
    }
}
</script>
<style>
.swiper {
    overflow: hidden;
}
</style>
<style lang="scss" scoped>
.oxford-wrapper {
    position: relative;
}

.section1 {
    padding: 169rem 0 166rem;
    background: url('../assets/image/oxfordNew/section1Bg.png');
    background-size: 100% 100%;
    text-align: center;
    position: relative;
}



.mobile {
    display: none !important;
}

.cn .section1 h1 {
    font-size: 56rem;
    font-weight: 700;
}

.section1 h1 {
    color: #036;
    text-align: center;
    font-size: 40rem;
    font-style: normal;
    font-weight: 600;
    line-height: 43rem;
    /* 107.5% */
    margin: 0 auto 26rem;
    max-width: 60vw;
}

.section1 h2 {
    color: #036;
    font-size: 32rem;
    font-style: normal;
    font-weight: 400;
    line-height: 35rem;
    /* 109.375% */
    margin: 0 auto;
    text-align: center;
    max-width: 55vw;

}

.section1 img {
    width: 349rem;
    height: 108rem;
    margin: 35rem auto 54rem;
}

.section1 .section1Btn {
    display: block;
    border-radius: 8px;
    background: #036;
    padding: 20rem;
    text-align: center;
    width: fit-content;
    color: #FFF;
    font-size: 16rem;
    font-style: normal;
    font-weight: 700;
    /* line-height: 24rem; 150% */
    margin: 0 auto;
    min-width: 224rem;
}

.section2 {
    padding: 79rem 260rem 126rem;
    background: #036;
}

.navList {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 28rem;
    background: #036;
    padding: 45rem 0 25rem;
    margin-bottom: -2rem;
    position: sticky;
    top: 80px;
    left: 0;
    z-index: 999;
}

.navList a {
    border-radius: 8px;
    border: 1.5px solid #FFB50E;
    color: #FFB50E;
    text-align: center;
    font-size: 24rem;
    font-weight: 500;
    padding: 18rem 19rem;
}

.navList .active {
    background: #FFB50E;
    color: #036;
}

.section2 {
    scroll-margin-top: 200rem;
}

.section2 h2 {
    color: #FFB50E;
    font-size: 36rem;
    font-weight: 600;
    line-height: 40rem;
    /* 117.647% */
    text-transform: capitalize;
    margin-bottom: 60rem;
}

.section2 .content {
    display: flex;
    gap: 55rem;
}

.section2 .left h2 {
    /* margin-top:22rem; */
}

.section2 .left .word {
    color: #FFF;
    font-size: 18rem;
    font-style: normal;
    font-weight: 400;
    line-height: 28rem;
    /* 155.556% */
}

.section2 .left .word:nth-child(n+2) {
    margin-top: 20rem;
}

.section2 .right {
    flex: 0 0 662rem;
    width: 662rem;
    height: 413rem;

}

.section2 .right iframe {
    width: 100%;
    height: 100%;
}

.section3 {
    padding: 100rem 260rem;
    background: #fff;
    background-size: 100% 100%;
    scroll-margin-top: 200rem;
}
.section3 iframe{
    width: 100%;
    height: 100%;
}
.section3 h2 {
    color: #036;
    text-align: center;
    font-size: 36rem;
    font-weight: 600;
    line-height: 23.111rem;
    margin-bottom: 80rem;
}

.section3 .oxford-slide {
    text-align: center;
    position: relative;
    overflow: hidden;

}

.section3 .oxford-slide .slide-img {
    width: 1160rem;
    height: 654rem;
    margin: 0 auto;
    position: relative;
    display: none;
}

.section3 .oxford-slide .slide-img svg:hover path {
    fill: #B9B4B4;
}

.section3 .oxford-slide .slide-img svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
}

.section3 .oxford-slide .swiper-button-next,
.section3 .oxford-slide .swiper-button-prev {
    color: #FFB50E;
    top: 320rem;
}

.section3 .oxford-slide .swiper-button-next:after,
.section3 .oxford-slide .swiper-button-prev:after {
    font-size: 60rem;

}

/* .section3 .swiper-slide{
  width:95%!important;
} */
.section3 .content {
    margin: 50rem auto 0;
    width: 1219rem;
    text-align: left;
}

.section3 .content .topTitle {
    padding-left: 51rem;
}

.section3 .content .topTitle .order {
    color: #4E4D4D;
    font-size: 18rem;
    font-weight: 500;
}

.section3 .content .topTitle .title {
    color: #036;
    font-size: 32.674rem;
    font-weight: 600;
    /* line-height: 53.266rem;  */
    margin: 18rem 0 24rem;
}

.section3 .content .splitLine {
    background: rgba(255, 181, 14, 0.67);
    height: 1px;
}

.section3 .content .descriptionBox {
    padding: 25rem 50rem;
    display: flex;
    flex-wrap: wrap;
    column-gap: 139rem;
}

.section3 .content .descriptionBox .contentBox:nth-child(n+3) {
    margin-top: 33rem;
}

.section3 .content .descriptionBox .contentBox ul {
    padding-left: 20rem;

}

.section3 .content .descriptionBox .contentBox ul li {
    list-style: disc;
    margin-bottom: 10rem;
}

.section3 .content .descriptionBox .contentBox:nth-child(2n-1) {
    flex: 0 0 620rem;
}

.section3 .content .descriptionBox .contentBox:nth-child(2n) {
    flex: 0 0 350rem;
}

.section3 .content .descriptionBox .title {
    color: #036;
    font-size: 18rem;
    font-weight: 500;
    /* line-height: 49.011rem;  */
    margin-bottom: 18rem;
}

.section3 .content .descriptionBox .describe {
    color: #4E4D4D;
    font-size: 16rem;
    font-weight: 400;
    line-height: 20rem;
}

.section4 {
    background: url('../assets/image/oxfordNew/section4Bg.png');
    background-size: 100% 100%;
    scroll-margin-top: 200rem;
    padding: 137rem 220rem 159rem;

}

.section4 h2 {
    color: #FFB50E;
    text-align: center;
    font-size: 36rem;
    font-style: normal;
    font-weight: 700;
    line-height: 23.111rem;
    /* 64.198% */
    margin-bottom: 72rem;
}

.section4 .sectionContainer .box {
    border-radius: 14.228rem;
    background: #EDF6FF;
    box-shadow: 0px 3.162px 8.695px 0px rgba(0, 0, 0, 0.08);
    display: flex;
    gap: 55rem;
    padding: 50rem;
    height: auto !important;
}

.section4 .sectionContainer .box img {
    width: 280rem;
    height: 300rem;
}

.section4 .sectionContainer .box .right {
    display: flex;
    flex-direction: column;
}

.section4 .sectionContainer .box .right .word1 {
    color: #036;
    font-size: 24rem;
    font-weight: 700;
    line-height: 23rem;
    /* 96.296% */
}

.section4 .sectionContainer .box .right .word2 {
    color: #036;
    font-size: 16rem;
    font-weight: 500;
    line-height: 23.111rem;
    /* 144.444% */
    margin-top: 14rem;
}

.section4 .sectionContainer .box .right .word3 {
    color: #393939;
    font-size: 18rem;
    font-weight: 500;
    line-height: 26rem;
    /* 162.5% */
    margin: 24rem 0 auto;
}

.section4 .sectionContainer .box .right .btn1 {
    border-radius: 8rem;
    background: #FFB50E;
    width: 220rem;
    padding: 18rem 0;
    color: #036;
    font-size: 16rem;
    font-weight: 700;
    text-align: center;
    cursor: pointer;
    margin-top: 10rem;
}

.section4 .swiper-slide {
    width: 85%;
}

.section5 {
    background: #fff;
    padding: 100rem 0rem 136rem;
    display: block;
    scroll-margin-top: 200rem;
}

.section5 h2 {
    color: #036;
    text-align: center;
    font-size: 36rem;
    font-weight: 600;
    line-height: 23.111rem;
    /* 64.198% */
    margin-bottom: 80rem;
}

.section5 .section5Container {
    display: flex;
    justify-content: center;
    gap: 39rem;
    margin-bottom: 60rem;
}

.section5 .section5Container .box {
    width: 441rem;
    height: 351rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    box-sizing: border-box;
    border-radius: 8rem;
    overflow: hidden;
}

.section5 .section5Container .box .word {
    width: 100%;
    display: flex;
    gap: 8rem;
    align-items: center;
    cursor: pointer;
    height: 109rem;
    background: linear-gradient(181deg, #03407C 39.65%, #03407C 85.87%);
    padding: 23rem 28rem;
}

.section5 .section5Container a:nth-child(1) .box {
    background: url('../assets/image/oxfordNew/section5Bg1.png') no-repeat;
    background-size: 100% 242rem;
}

.section5 .section5Container a:nth-child(2) .box {
    background: url('../assets/image/oxfordNew/section5Bg2.png') no-repeat;
    background-size: 100% 242rem;
}

.section5 .section5Container a:nth-child(3) .box {
    background: url('../assets/image/oxfordNew/section5Bg3.png') no-repeat;
    background-size: 100% 242rem;
}

.section5 .section5Container .box .word div {
    flex: 1;
    color: #FFF;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 24rem;
    font-style: normal;
    font-weight: 500;
    line-height: 124%;
}

.section5 .section5Container .box .word .svg {
    width: 13rem;
    height: 18rem;
}

.section5 .partnerList {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 31rem;
}

.section5 .partnerList img:nth-child(1) {
    width: 187rem;
}

.section5 .partnerList img:nth-child(2) {
    width: 79rem;
}

.section5 .partnerList img:nth-child(3) {
    width: 62rem;
}

.section5 .partnerList img:nth-child(4) {
    width: 68rem;
}

.section5 .partnerList img:nth-child(5) {
    width: 191rem;
}

.section5 .partnerList img:nth-child(6) {
    width: 167rem;
}

.section5 .partnerList img:nth-child(7) {
    width: 167rem;
}

.section5 .partnerList img:nth-child(8) {
    width: 51rem;
}

.section6 {
    background: url('../assets/image/oxfordNew/section6Bg.png');
    background-size: 100% 100%;
    padding: 140rem 0 130rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 150rem;
    scroll-margin-top: 200rem;

}
.cn .section6 .left{
    flex: 0 0 450rem
}
.section6 .left {
    flex: 0 0 545rem;
}

.section6 .left .title {
    color: #FFB50E;
    font-size: 36rem;
    font-style: normal;
    font-weight: 700;
    line-height: 23.111rem;
    /* 64.198% */
    margin-bottom: 40rem;
    white-space: nowrap;
}

.cn .section6 .left .describe {
    line-height: 34rem;
}

.section6 .left .describe {
    color: #FFF;
    font-size: 28rem;
    font-style: normal;
    font-weight: 500;
    line-height: 28rem;
}

.section6 .left .describe:nth-child(2) {
    margin-top: 25rem;
}

.section6 .right {
    flex: 0 0 516rem;
    padding: 50rem 30rem;
    background: #F7F9F8;
    border-radius: 10rem;

}

.section6 .right input {
    padding-left: 33rem;
    margin-bottom: 20rem;
    border-radius: 8px;
    border: 1px solid #EFEFEF;
    height: 60rem;
    width: 100%;
    background: #ECECEC;
    color: #036;
    font-size: 20rem;
    font-weight: 600;
    line-height: 102%;
}

.section6 .right #formVerify {
    padding-right: 140rem;
}

.section6 .right .verify_img {
    width: 132rem;
    height: 42rem;
}

.section6 .right input::placeholder {
    color: #036;

}

.section6 .right button {
    width: 457rem;
    height: 65rem;
    padding: 18rem 117rem;
    text-align: center;
    color: #036;
    font-size: 24rem;
    font-weight: 700;
    line-height: 102% !important;
    margin-top: 15rem;
    border-radius: 8rem;
    background: #FFB50E;
}

@media screen and (max-width: 996px) {
    .pc {
        display: none !important;
    }

    .mobile {
        display: block !important;
    }

    .section1 {
        height: 800rem;
        padding: 0rem 60rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: url('../assets/image/oxfordNew/section1Bgm.png');
        background-size: 100% 100%;
        text-align: center;

    }

    .section1 .section1Popover a {
        font-size: 24rem;
        padding: 13rem;
        right: 37rem;
        width: auto;
    }

    .section1 .section1Btn {
        font-size: 24rem;
        line-height: 24rem;
        font-weight: 500;

    }

    .ru .section1 h2 {
        font-size: 28rem;
        line-height: 32rem;
        width: 110%;
        margin-left: -5%;
        max-width: 90vw;
    }

    .mn .section1 h2,
    .vi .section1 h2 {
        width: 110%;
        margin-left: -5%;
        max-width: 90vw;
    }

    .hi .section1 h1,
    .pt .section1 h1 {
        font-size: 42rem;
        width: 110%;
        margin-left: -4%;
    }

    .vi .section1 h1,
    .ug .section1 h1,
    .th .section1 h1 {
        width: 110%;
        margin-left: -4%;
    }

    .ru .section1 h1 {
        font-size: 30rem;
        line-height: 40rem;
    }

    .es .section1 h1 {
        font-size: 40rem;
    }

    .cn .section1 h1 {
        white-space: nowrap;
        font-size: 50rem;
        line-height: 58rem;
        font-weight: 800;
    }

    .cn .section1 h2 {
        white-space: nowrap;
        font-size: 30rem;
        margin: 25rem 0 38rem;
    }

    .section1 h1 {
        font-size: 45rem;
        line-height: 56rem;
        font-weight: 600;
        margin-bottom: 0;
        max-width: 90vw;
    }

    .section1 h2 {
        font-size: 32rem;
        line-height: 45rem;
        margin: 38rem 0;
        max-width: 85vw;

    }

    .section1 img {
        width: 349rem;
        height: 107rem;
        margin-bottom: 54rem;
    }

    .section1 a {
        width: 290rem;
        font-size: 24rem;
        padding: 20rem 0;
    }

    .navList {
        display: none;
    }

    .section2 {
        padding: 80rem 40rem 100rem;
    }

    .section2 .content {
        flex-direction: column;
    }

    .section2 h2 {
        font-size: 36rem;
        font-weight: 600;
        line-height: 45rem;
        /* 111.111% */
        text-transform: capitalize;
        margin-bottom: 64rem;
    }

    .section2 .left .word {
        font-size: 28rem;
        font-weight: 400;
        line-height: 34rem;
    }

    .section3 {
        padding: 80rem 0 100rem;
    }

    .section3 h2 {
        font-size: 36rem;
        font-weight: 700;
        line-height: 23.111rem;
        margin-bottom: 64rem;
    }

    .section3 .oxford-slide .swiper-button-next,
    .section3 .oxford-slide .swiper-button-prev {
        display: none;
    }

    .section3 .oxford-slide .swiper-wrapper {
        width: 680rem;
    }

    .section3 .oxford-slide .slide-img {
        width: 680rem;
        height: 377rem;
        margin: 0;
    }

    .section3 .content {
        padding-left: 40rem;
        margin: 71rem 0 0;
        width: 670rem;
    }

    .section3 .content .topTitle {
        padding: 0rem;
    }

    .section3 .content .topTitle .order {
        font-size: 24rem;
    }

    .section3 .content .topTitle .title {
        margin: 23rem 0 30rem;
    }

    .section3 .content .descriptionBox {
        padding: 30rem 0 0;
        gap: 50rem;
        flex-direction: column;
    }

    .section3 .content .descriptionBox .contentBox:nth-child(n+3) {
        margin-top: 0;
    }

    .section3 .content .descriptionBox .contentBox:nth-child(2n-1) {
        flex: 1;
    }

    .section3 .content .descriptionBox .contentBox:nth-child(2n) {
        flex: 1;
    }

    .section3 .content .descriptionBox .title {
        font-size: 28rem;
        margin-bottom: 24rem;
    }

    .section3 .content .descriptionBox .describe {
        font-size: 24rem;
        line-height: 28rem;
    }

    .section4 {
        padding: 80rem 0 100rem;
        background: url('../assets/image/oxfordNew/section4Bgm.png');
        background-size: 100% 100%;
    }

    .section4 h2 {
        margin-bottom: 64rem;
    }

    .section4 .sectionContainer .box {
        width: 610rem;
        height: auto;
        padding: 52rem;
        flex-direction: column;
        gap: 0;
    }

    .section4 .sectionContainer .box img {
        width: 506rem;
        height: 547.564rem;

    }

    .section4 .sectionContainer .box .right {
        flex: 1;
    }

    .section4 .sectionContainer .box .right .word1 {
        font-size: 30rem;
        margin: 31rem 0;
    }

    .section4 .sectionContainer .box .right .word2 {
        font-size: 24rem;
        line-height: 28rem;
        margin-top: 0;
    }

    .section4 .sectionContainer .box .right .word3 {
        font-size: 24rem;
        line-height: 32rem;
        margin: 40rem 0 auto;
    }

    .section4 .sectionContainer .box .right .btn1 {
        margin: 0 auto;
        width: fit-content;
        margin-top: 10rem;
        padding: 18rem 30rem;
        font-size: 24rem;

    }

    .section5 {
        padding: 80rem 0 100rem;
    }

    .section5 h2 {
        font-size: 36rem;
        font-weight: 700;
    }

    .section5 .sectionContainer {
        margin-bottom: 78rem;
    }

    .section5 .section5Container .box:nth-child(1) {
        background: url('../assets/image/oxfordNew/section5Bg1m.png') no-repeat;
        background-size: 100% 315rem;
    }

    .section5 .section5Container .box:nth-child(2) {
        background: url('../assets/image/oxfordNew/section5Bg2m.png') no-repeat;
        background-size: 100% 315rem;
    }

    .section5 .section5Container .box:nth-child(3) {
        background: url('../assets/image/oxfordNew/section5Bg3m.png') no-repeat;
        background-size: 100% 315rem;
    }

    .section5 .section5Container .box .word {
        height: 142rem;
    }

    .section5 .section5Container .box {
        width: 650rem;
        height: 457rem;
        /* padding:0 52rem 24rem; */
        transform: scale(.9);
    }

    .section5 .section5Container {
        align-items: center;
    }

    .section5 .section5Container .swiper-slide-active {
        transform: scale(1);
    }

    .section5 .section5Container {
        justify-content: flex-start;
        gap: 0;
    }

    .section5 .partnerList {
        flex-wrap: wrap;
    }

    .section5 .partnerList img:nth-child(5),
    .section5 .partnerList img:nth-child(6),
    .section5 .partnerList img:nth-child(7) {
        order: 3;
    }

    .section5 .partnerList img:nth-child(8) {
        order: 2;
    }

    .section6 {
        flex-direction: column;
        gap: 68rem;
        padding: 80rem 40rem 100rem;
    }

    .section6 .left {
        flex: auto!important;
    }

    .section6 .left .title {
        font-size: 36rem;
        font-weight: 600;
        /* padding:0 60rem; */
        white-space: wrap;
        line-height: 40rem;
    }

    .section6 .left .describe {
        margin: 36rem 0 0;
        /* width: 554rem; */
        font-size: 28rem;
        /* padding:0 60rem; */
        /* white-space:nowrap; */
    }

    .section6 .right {
        padding: 50rem 60rem;
        height: 600rem;
    }

    .section6 .right #formVerify {
        padding-right: 180rem;
    }

    .section6 .right .verify_img {
        top: 10rem;
        height: 60rem;
        width: 175rem;
    }

    .section6 .right input {
        height: 80rem;
        margin-bottom: 24rem;
    }

    .section6 .right button {
        width: 100%;
        height: 40rem;
        padding: 20rem 0;
        box-sizing: content-box;
    }
}
</style>